export function flatten (obj, delimiter = '.', maxDepth = Infinity, currentDepth = 0, prefix = '') {
  const result = {}

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = prefix ? `${prefix}${delimiter}${key}` : key

      if (typeof obj[key] === 'object' && obj[key] !== null && currentDepth < maxDepth) {
        const nestedObj = flatten(obj[key], delimiter, maxDepth, currentDepth + 1, newKey)
        Object.assign(result, nestedObj)
      } else {
        result[newKey] = obj[key]
      }
    }
  }

  return result
}

export function flattenNoFollow (
  obj,
  delimiter = '.',
  maxDepth = Infinity,
  currentDepth = 0,
  prefix = ''
) {
  const result = {}
  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue
    const value = obj[key]
    const newKey = prefix ? `${prefix}${delimiter}${key}` : key

    if (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      currentDepth < maxDepth
    ) {
      const nested = flattenNoFollow(
        value,
        delimiter,
        maxDepth,
        currentDepth + 1,
        newKey
      )
      Object.assign(result, nested)
    } else {
      result[newKey] = value
    }
  }
  return result
}
